import BaseAction from "./BaseAction";
import SessionalDetailsReducer from "../reducers/SessionalDetailsReducer";

class SessionalDetailsAction extends BaseAction {
  onOptionChange = (newData) => {
    const { grid } = this.data();
    const newGrid = { ...grid, data: newData };
    this.dispatch({ grid: newGrid });
  };
}

const action = new SessionalDetailsAction(SessionalDetailsReducer);

export default action;
